/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_SearchInputs */

const th_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พิมพ์ชื่อ`)
};

const en_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a name`)
};

const ja_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を入力`)
};

const zh_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入姓名`)
};

const es_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un nombre`)
};

const pt_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um nome`)
};

const id_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik nama`)
};

const fr_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un nom`)
};

const tl_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-type ng pangalan`)
};

const vi_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ tên`)
};

const ko_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름 입력`)
};

const de_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namen eingeben`)
};

const ru_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите имя`)
};

const tr_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad yazın`)
};

const it_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi un nome`)
};

const pl_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz imię`)
};

const uk_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть ім'я`)
};

const hi_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम लिखें`)
};

const ar_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتب اسمًا`)
};

const ms_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taip nama`)
};

const bn_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম লিখুন`)
};

const zh_tw2_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入姓名`)
};

const zh_hk2_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入姓名`)
};

const ur_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام لکھیں`)
};

const fa_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نامی بنویسید`)
};

const sw_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andika jina`)
};

const nl_meeting_search = /** @type {(inputs: Meeting_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ een naam`)
};

/**
* | output |
* | --- |
* | "Type a name" |
*
* @param {Meeting_SearchInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_search = /** @type {((inputs?: Meeting_SearchInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_SearchInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_search(inputs)
	if (locale === "ja") return ja_meeting_search(inputs)
	if (locale === "zh") return zh_meeting_search(inputs)
	if (locale === "es") return es_meeting_search(inputs)
	if (locale === "pt") return pt_meeting_search(inputs)
	if (locale === "id") return id_meeting_search(inputs)
	if (locale === "fr") return fr_meeting_search(inputs)
	if (locale === "tl") return tl_meeting_search(inputs)
	if (locale === "vi") return vi_meeting_search(inputs)
	if (locale === "ko") return ko_meeting_search(inputs)
	if (locale === "de") return de_meeting_search(inputs)
	if (locale === "ru") return ru_meeting_search(inputs)
	if (locale === "tr") return tr_meeting_search(inputs)
	if (locale === "it") return it_meeting_search(inputs)
	if (locale === "pl") return pl_meeting_search(inputs)
	if (locale === "uk") return uk_meeting_search(inputs)
	if (locale === "hi") return hi_meeting_search(inputs)
	if (locale === "ar") return ar_meeting_search(inputs)
	if (locale === "ms") return ms_meeting_search(inputs)
	if (locale === "bn") return bn_meeting_search(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_search(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_search(inputs)
	if (locale === "ur") return ur_meeting_search(inputs)
	if (locale === "fa") return fa_meeting_search(inputs)
	if (locale === "sw") return sw_meeting_search(inputs)
	if (locale === "nl") return nl_meeting_search(inputs)
	return en_meeting_search(inputs)
});